import { useEffect, useState } from "react";
import { generatePreferenceInsights } from "services/preferenceAI";
import { buildFallbackInsights } from "utils/preferenceFallback";
import { sanitizeInsights } from "utils/sanitizePreferncesAi";

// In-memory cache to prevent regenerating AI insights

const insightsCache = {};

export const usePreferenceInsights = (rawData) => {
  const [insights, setInsights] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!rawData) return;

    const cacheKey = JSON.stringify(rawData);

    // Use cached insights if available
    if (insightsCache[cacheKey]) {
      setInsights(insightsCache[cacheKey]);
      return;
    }

    let cancelled = false;

    const runAI = async () => {
      setLoading(true);

      try {
        const ai = await generatePreferenceInsights(rawData);

        if (!cancelled) {
          const safe = sanitizeInsights(ai);

          // Save to cache
          insightsCache[cacheKey] = safe;

          setInsights(safe);
        }
      } catch (err) {
        console.error("AI failed → using fallback", err);

        if (!cancelled) {
          const fallback = buildFallbackInsights(rawData);

          // Save fallback to cache too
          insightsCache[cacheKey] = fallback;

          setInsights(fallback);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    runAI();

    return () => {
      cancelled = true;
    };
  }, [rawData]);

  return { insights, loading };
};
